import Component from './Component';
import ModalComponent from './ModalComponent';

export default class TimeSlotsPopupComponent extends Component {
    get SELECTORS() {
        return {
            html: 'html',
            getTimeSlots: '.js-get-timeslots',
            popupContent: '.js-info-time-slots-dom'
        }
    }

    get DATA() {
        return {
            store: 'data-store',
            deliveryMode: 'data-deliverymode',
        }
    }

    get PAGES() {
        return {
        }
    }

    get TEMPLATES() {
        return {
            timeSlotsTemplateId: 'timeSlotsPopup--template'
        }
    }

    constructor() {
        super();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.DATA.CSRFToken);
        this.ModalComponent = new ModalComponent();
    }

    getTimeSlots(element) {
        const store = 'store=' + element.getAttribute(this.DATA.store),
            mode = element.getAttribute(this.DATA.deliveryMode),
            deliveryMode = 'deliveryMode=' + mode;
        
        fetch(this.endpoints.CART_TIMESLOTS.url + store + '&' + deliveryMode, {
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                let results = { 
                    'DRIVE' : (mode === 'PICKUP' ? true : false), 
                    days : data
                };
                for (let index = 0; index < data.length; index++) {
                    let isActive = false;
                    data[index].timeSlots.AFTERNOON.filter((hour) => {
                        if(hour.active) {
                            isActive = true;
                        }
                    });
                    data[index].timeSlots.MORNING.filter((hour) => {
                        if(hour.active) {
                            isActive = true;
                        }
                    });
                    if(isActive) {
                        results = { 
                            'DRIVE' : (mode === 'PICKUP' ? true : false), 
                            'startAt' : index,
                            days : data
                        };
                        break;   
                    }
                }
                this.renderMustache(this.TEMPLATES.timeSlotsTemplateId, document.querySelector(this.SELECTORS.popupContent), results);
                this.importComponentCreate('CarouselComponent');   

                // Add a listener for keydown event on arrows
                document.querySelectorAll('.glide__arrow').forEach(arrow => {
                    arrow.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            arrow.click(); // Simulate click on button
                        }
                    });
                });
            }
        })
    }

    bindEvents() {
        this.events.on('click', this.SELECTORS.getTimeSlots, (e) => {
            const element = e.target.matches(this.SELECTORS.getTimeSlots) ? e.target : e.target.closest(this.SELECTORS.getTimeSlots);
            this.getTimeSlots(element);
        });
    }

    render() {
        this.log('render TimeSlots Popup');
        this.bindEvents();       
    }
}
